module.exports = __webpack_public_path__ + "img/icon-audit.728c2b12.png";